// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"style_itemsContainer__Gbusy","items":"style_items__RZnKX","title":"style_title__CBukB","texte":"style_texte__euXHT"};